/* TopBar auto-generated by npm run generator */
import { AppBar, Divider, makeStyles, Theme, Toolbar, Typography } from "@material-ui/core"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import { DropdownMenu } from "@qlarity/common"
import clsx from "clsx"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import { Link, useHistory } from "react-router-dom"
import { PATHS } from "Router"
import Store from "store/Store"
import { ReactComponent as Qlarity } from "../../../assets/Qlarity.svg"

interface TopBarProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
    topBar: {
        backgroundColor: theme.palette.common.white,
        minHeight: theme.spacing(8),
    },
    toolbar: {
        // display: "grid",
        // gridTemplateColumns: "1fr repeat(auto-fit, auto)",
    },
    qlarity: {
        maxWidth: theme.spacing(20),
    },
    name: {
        color: theme.palette.primary.dark,
    },
    divider: {
        background: theme.palette.secondary.dark,
    },
}))

const TopBar: React.FC<TopBarProps> = (props) => {
    const classes = useStyles()
    const className = clsx(classes.topBar, props.className)
    const history = useHistory()
    const menuOpts = [
        {
            name: "Profile",
            callback: () => history.push(PATHS.PROFILE()),
        },
        {
            name: "Log out",
            callback: () => Store.auth.logout(),
        },
    ]
    return (
        <Toolbar className={className}>
            <AppBar className={className} color="inherit" elevation={0}>
                <Toolbar className={classes.toolbar}>
                    <Link to={PATHS.HOME()}>
                        <Qlarity className={classes.qlarity} />
                    </Link>
                    <div style={{ flex: 1 }} />
                    {Store.auth.isLoggedIn && (
                        <>
                            <Typography variant="body2">
                                Welcome,{" "}
                                <Typography variant="inherit" className={classes.name}>
                                    {Store.auth.authUser?.displayName}
                                </Typography>
                            </Typography>
                            <DropdownMenu options={menuOpts} noBackground>
                                <KeyboardArrowDownIcon />
                            </DropdownMenu>
                        </>
                    )}
                </Toolbar>
                <Divider className={classes.divider} />
            </AppBar>
        </Toolbar>
    )
}

export default observer(TopBar)
